import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { msg } from 'gt-react';
import { z } from 'zod';
// fallow-ignore-next-line circular-dependency -- co-located route modules import their pathless layout parent from the central tree during the route migration.
import { backgroundAgentsLayoutRoute } from 'src/routes';

export const Route = createRoute({
  getParentRoute: () => backgroundAgentsLayoutRoute,
  path: 'procedures/imports/$importId',
  component: lazyRouteComponent(
    () => import('../../../operator/OperatorSopImportReviewPage'),
    'OperatorSopImportReviewPage',
  ),
  loader: () => ({
    crumb: msg('Review import', { context: 'page breadcrumb' }),
    crumbTo: '/agents/procedures',
  }),
  validateSearch: z.object({}),
});
